import { useMutation } from "@tanstack/react-query";
import { forgotPasswordRequest } from "../requests/auth";
import { useToast } from "../../contexts/toast/Context";
import {
  GymSelectionRequiredError,
  type AvailableGym,
  type ForgotPasswordInput,
} from "../../utils/zod/auth";

export const useForgotPassword = () => {
  const { showToast } = useToast();

  const mutation = useMutation({
    mutationFn: (body: ForgotPasswordInput) => forgotPasswordRequest(body),
    onSuccess: () => {
      showToast(
        "Se ha enviado un correo para restablecer la contraseña",
        "success",
      );
    },
    onError: (error: Error) => {
      if (error instanceof GymSelectionRequiredError) return;
      showToast(error.message, "error");
    },
  });

  const availableGyms: AvailableGym[] | null =
    mutation.error instanceof GymSelectionRequiredError
      ? mutation.error.availableGyms
      : null;

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
    availableGyms,
    resetGymSelection: mutation.reset,
  };
};
